export const DOCUMENT_LIST = "Document/LIST";
export const DOCUMENT_ERROR = "Document/ERROR";
export const LOADING = "Document/LOADING";
export const APICALL = "Document/API_CALL";
export const UPDATE_FREEHOLDER_EMAIL = "Document/FREEHOLDEREMAIL";
